import React from 'react';
import { getImageUrl } from 'helpers/getImageUrl';
import * as Styled from './styled';
import { BackgroundImageFromUrlProps } from './types';

const BackgroundImageFromUrl: React.FC<BackgroundImageFromUrlProps> = ({
    isLoading = false,
    imageUrl,
    imageSize = 500,
    fallback,
    fallbackSrc,
    alt,
    loading = 'lazy',
}) => {
    if (isLoading || (!imageUrl && !fallback && !fallbackSrc)) {
        return <Styled.BackgroundSkeleton />;
    }

    const src = getImageUrl(imageUrl, imageSize);
    const src2x = getImageUrl(imageUrl, imageSize * 2);
    const srcSet = `${src2x} 2x, ${src}`;

    return (
        <Styled.BackgroundImage
            src={src}
            srcSet={srcSet}
            alt={alt}
            fallback={fallback}
            fallbackSrc={fallbackSrc}
            loading={loading}
        />
    );
};

export default BackgroundImageFromUrl;
